export default class MapIndexControls {
  constructor() {
    this.listToggles = document.getElementsByClassName('js-list-toggle');
    this.chartToggles = document.getElementsByClassName('js-chart-toggle');
  }

  addListeners() {
    Array.from(this.listToggles).forEach((element) => {
      element.addEventListener('click', () => {
        $('#js-record-list-container').show();
        $('#js-record-metrics-container').hide();
      })
    });

    Array.from(this.chartToggles).forEach((element) => {
      element.addEventListener('click', () => {
        $('#js-record-metrics-container').show();
        $('#js-record-list-container').hide();
      })
    });
  }
}